$(document).ready(function(){

	$('.slick-gallery').each(function(key, item) {
	    $(this).slick({
	        dots: false,
	        arrows: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			nextArrow: '<button type="button" class="slick-arrow slick-next"><svg class="gfx-arrownext-dims"><use xlink:href="#arrownext"></use></svg></button>',
			prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg class="gfx-arrowprev-dims"><use xlink:href="#arrowprev"></use></svg></button>',
			appendArrows: $(this).closest('.mxm_gallery').find('.slick-action'),
	        responsive: [
	            {
	                breakpoint: 1025,
	                settings: {
	                    slidesToShow: 2
	                }
	            },
	            {
	                breakpoint: 768,
	                settings: {
	                    slidesToShow: 1
	                }
	            }
	        ],
	    });
    });

    $('.slick-gallery-numbered').each(function(key, item) {
	    $(this).slick({
	        dots: true,
	        arrows: false,
	        appendDots: $(this).closest('.mxm_gallery').find('.slick-action'),
	         customPaging : function(slider, i) {
		        var number = $(slider.$slides[i]).data('number');
		        return '<a href="#!">'+number+'</a>';
		    },
	    });
	 });

    $('.slick-people').each(function(key, item) {
    	$(this).slick({
	        dots: false,
	        arrows: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			infinite: true,
			lazyLoad: 'progressive',
			nextArrow: '<button type="button" class="slick-arrow slick-next"><svg class="gfx-arrownext-dims"><use xlink:href="#arrownext"></use></svg></button>',
			prevArrow: '<button type="button" class="slick-arrow slick-prev"><svg class="gfx-arrowprev-dims"><use xlink:href="#arrowprev"></use></svg></button>',
			// appendArrows: $(this).closest('.mxm_people').find('.slick-action'),
	        responsive: [
	            {
	                breakpoint: 1025,
	                settings: {
	                    slidesToShow: 4,
	                    slidesToScroll: 4
	                }
	            },
	            {
	                breakpoint: 768,
	                settings: {
	                    slidesToShow: 2,
	                    slidesToScroll: 2
	                }
	            },
	            {
	                breakpoint: 480,
	                settings: {
	                    slidesToShow: 1,
	                    slidesToScroll: 1
	                }
	            }
	        ],
	    });
    });
});


/** WEBPACK FOOTER **
 ** ./Frontend/js/modules/slider/index.js
 **/